import { useQuery } from "@apollo/client";
import { Navigate, Outlet } from "react-router-dom";
import { ME_QUERY } from "../queries/waves";

export default function RequireAdmin() {
    const { loading, error, data } = useQuery(ME_QUERY);
    if (loading) return <div style={{ padding: 24 }}>Checking admin access…</div>;
    if (error || !data || !data.me) return <Navigate to="/" replace />;
    if (!data.me.isAdmin) return <Navigate to="/" replace />;
    return <Outlet />;
}
